import { render, staticRenderFns } from "./message.vue?vue&type=template&id=5ca73286&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&lang=less"
import style1 from "./message.vue?vue&type=style&index=1&id=5ca73286&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca73286",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/components/message.vue
// module id = null
// module chunks = 